import ResizablePanel from '../../components/Resizeable/ResizablePanel';
import CornRXGrid from './CornRXGrid';
import CornRxMap from './CornRXMap';
import { Section } from '../Section';

export default function CornRXPage() {
  return (
    <Section>
      <ResizablePanel topPanel={<CornRxMap />} bottomPanel={<CornRXGrid />} />
    </Section>
  );
}
